var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { assert } from '@ember/debug';
export const DEFAULT_OBSERVER_OPTIONS = {};
function cleanup(instance) {
  instance.unobserve.call(instance);
}
let DidIntersectModifier = (_dec = service('ember-scroll-modifiers@observer-manager'), _class = class DidIntersectModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "observerManager", _descriptor, this);
    _defineProperty(this, "onEnter", void 0);
    _defineProperty(this, "onExit", void 0);
    // A flag that determines if we should use intersection observer or use no-op, e.g IE11, no polyfill.
    _defineProperty(this, "_isObservable", 'IntersectionObserver' in window);
    // Observer options need to be specified, so the intersection observer admin service can use it as a key to unobserve, in case there is multiple observers on the same element. By default, we're using the same options that intersection observer uses.
    _defineProperty(this, "_options", DEFAULT_OBSERVER_OPTIONS);
    // Used to track number of enter and exit intersections that have happened.
    _initializerDefineProperty(this, "_numOfEnters", _descriptor2, this);
    _initializerDefineProperty(this, "_numOfExits", _descriptor3, this);
    _initializerDefineProperty(this, "_maxEnterIntersections", _descriptor4, this);
    _initializerDefineProperty(this, "_maxExitIntersections", _descriptor5, this);
    // Track if we have already initialized `addEnterCallback` or `addExitCallback`
    _defineProperty(this, "_hasSetupEnterCallback", false);
    _defineProperty(this, "_hasSetupExitCallback", false);
    // the element
    _defineProperty(this, "element", void 0);
    registerDestructor(this, cleanup);
  }
  get _isExceedingMaxEnters() {
    if (!Number.isInteger(this._maxEnterIntersections)) {
      return false;
    }
    return this._numOfEnters > this._maxEnterIntersections;
  }
  get _isExceedingMaxExits() {
    if (!Number.isInteger(this._maxExitIntersections)) {
      return false;
    }
    return this._numOfExits > this._maxExitIntersections;
  }
  observe() {
    if (!this._isObservable) {
      return;
    }
    this.observerManager.observe(this.element, this._options);
  }
  unobserve() {
    if (!this._isObservable) {
      return;
    }
    this.observerManager.unobserve(this.element, this._options);
  }
  modify(element, positional, named) {
    this.element = element;
    if (!this._isObservable) {
      return;
    }
    let {
      onEnter,
      onExit,
      maxEnter,
      maxExit,
      options,
      isObserving = true
    } = named;
    assert('onEnter or/and onExit is required', onEnter || onExit);
    if (onEnter) {
      assert('onEnter must be a function', typeof onEnter === 'function');
      this.onEnter = onEnter;
    }
    if (onExit) {
      assert('onExit must be a function', typeof onExit === 'function');
      this.onExit = onExit;
    }

    // We should technically accept 0, in case of programmatic changes
    if (maxEnter || maxEnter === 0) {
      assert('maxEnter must be an integer', Number.isInteger(maxEnter));
      this._maxEnterIntersections = maxEnter;
    }

    // We should accept 0 here too.
    if (maxExit || maxExit === 0) {
      assert('maxExit must be an integer', Number.isInteger(maxExit));
      this._maxExitIntersections = maxExit;
    }
    if (!this._hasSetupEnterCallback && this.onEnter && !this._isExceedingMaxEnters) {
      this.observerManager.addEnterCallback(this.element, (...args) => {
        if (this.isDestroying) {
          return;
        }
        this._numOfEnters++;
        if (this._isExceedingMaxEnters && (!this.onExit || this._isExceedingMaxExits)) {
          this.unobserve();
          return;
        }
        if (!this._isExceedingMaxEnters) {
          this.onEnter(...args);
        }
      });
      this._hasSetupEnterCallback = true;
    }
    if (!this._hasSetupExitCallback && this.onExit && !this._isExceedingMaxExits) {
      this.observerManager.addExitCallback(this.element, (...args) => {
        if (this.isDestroying) {
          return;
        }
        this._numOfExits++;
        if ((!this.onEnter || this._isExceedingMaxEnters) && this._isExceedingMaxExits) {
          this.unobserve();
          return;
        }
        if (!this._isExceedingMaxExits) {
          this.onExit(...args);
        }
      });
      this._hasSetupExitCallback = true;
    }
    if (options) {
      this._options = options;
    }
    if (isObserving) {
      this.observe();
    } else {
      this.unobserve();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "observerManager", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_numOfEnters", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_numOfExits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_maxEnterIntersections", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_maxExitIntersections", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DidIntersectModifier as default };